export default __webpack_public_path__ + "static/media/z98.2ee8c028.png";